import PropTypes from 'prop-types';

export const visibilitiesReportType = PropTypes.shape({
  totals: PropTypes.bool,
  igAvgFeedEngagements: PropTypes.bool,
  igAvgFeedReachEngRate: PropTypes.bool,
  averageReach: PropTypes.bool,
  averageImpressions: PropTypes.bool,
  averageStoriesReach: PropTypes.bool,
  averageStoriesImpressions: PropTypes.bool,
  igVideoViews: PropTypes.bool,
  igTotalSwipeUps: PropTypes.bool,
  igCpe: PropTypes.bool,
  igCpm: PropTypes.bool,
  igAvgFeedFollowerEngRate: PropTypes.bool,
});
